module.exports = __webpack_public_path__ + "static/media/videoPreview2.91c0dc5f.mp4";